import { render, staticRenderFns } from "./LoadingDefault.vue?vue&type=template&id=37b79d36&scoped=true"
import script from "./LoadingDefault.vue?vue&type=script&lang=js"
export * from "./LoadingDefault.vue?vue&type=script&lang=js"
import style0 from "./LoadingDefault.vue?vue&type=style&index=0&id=37b79d36&prod&scoped=true&lang=css"
import style1 from "./LoadingDefault.vue?vue&type=style&index=1&id=37b79d36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b79d36",
  null
  
)

export default component.exports